import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {gsap, TimelineLite} from "gsap";
import {PearlHarborGameAssets} from "../PearlHarborGameAssets";
import {PearlHarbor} from "../PearlHarbor";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {BetClusterWinData} from "../server/PearlHarborData";
import {PearlHarborHelper} from "../utils/PearlHarborHelper";
import {PearlHarborGameConfig} from "../PearlHarborGameConfig";

export class PearlHarborInitialWinView extends PIXI.Container implements StageLayer {

    public static DELAY_BETWEEN_COMBO_WINS:number = 0.3;
    private static WIN_ABOVE_LEVEL_01:number = 50;

    private readonly _maxWinNumberWidth:number = 130;

    constructor() {
        super();
        this.name = "PearlHarborInitialWinView";
    }

    //Counts all the wins that are below 50 * base bet
    private calculateAboveLevel01LingerTime():number {
        const winData = PearlHarbor.model.gameData.betClusterWins;
        let belowLevelWins:number = 0;
        for(let i:number = 0; i < winData.length; i++) {
            if(winData[i].multipliedAmount < (PearlHarborInitialWinView.WIN_ABOVE_LEVEL_01 * PearlHarbor.model.gameData.playedBetValue)) {
                belowLevelWins++;
            }
        }
        return 0.5 + (belowLevelWins * PearlHarborInitialWinView.DELAY_BETWEEN_COMBO_WINS);
    }

    public playWinNumbers(betClusterWins:BetClusterWinData, skipped:boolean):TimelineLite {
        let text = PearlHarbor.apiPlugin.currency.formatValue(MathHelper.roundToDecimals(betClusterWins.amount, 2));
        if(betClusterWins.multiplier > 1) {
            text += ` x ${betClusterWins.multiplier}`;
        }
        let startScale = 1;
        let endScale = startScale;
        let lingerTime = 0;
        const winAboveLevel01LingerTime = this.calculateAboveLevel01LingerTime();
        const winNumber = new PIXI.BitmapText(text, {
            fontName : PearlHarborGameAssets.BITMAP_FONT_MULTIPLIER,
            fontSize : 50
        });
        (<PIXI.Point>winNumber.anchor).set(0, 0.1);
        this.addChild(winNumber);
        winNumber.updateTransform();
        if(winNumber.width > this._maxWinNumberWidth) {
            const scale:number = MathHelper.roundToDecimals(this._maxWinNumberWidth / winNumber.width, 2);
            winNumber.scale.set(scale);
            endScale = startScale = scale;
        }
        if(betClusterWins.multipliedAmount > (PearlHarborInitialWinView.WIN_ABOVE_LEVEL_01 * PearlHarbor.model.gameData.playedBetValue)) {
            lingerTime = winAboveLevel01LingerTime;
            endScale = startScale * 1.2;
        }
        const startPositions = this.findFirstNoWildSymbolPosition(betClusterWins, winNumber.width);
        winNumber.position.set(startPositions[0], startPositions[1]);

        const timeline = gsap.timeline();
        timeline.add([
            gsap.to(winNumber.scale, {duration : 0.5, x : endScale, y : endScale}),
            gsap.to(winNumber, {duration : 0.5, y : startPositions[1] - startPositions[2]})
        ], 1.1);
        timeline.add(gsap.to(winNumber, {duration : 0.1, alpha : 0, delay : lingerTime}));
        if(lingerTime > 0) {
            timeline.add(gsap.to(winNumber.scale, {duration : 0.1, x : startScale, y : startScale}), "-=0.15");
        }
        timeline.add(() => {
            if(winNumber.parent) {
                this.removeChild(winNumber);
            }
            winNumber.destroy();
        });
        if(skipped) {
            timeline.timeScale(4);
        }
        return timeline;
    }

    private findFirstNoWildSymbolPosition(betClusterWins:BetClusterWinData, textWidth:number):number[] {
        for(let reelId = betClusterWins.startReel!; reelId < 7; reelId++) {
            for(let symId = 0; symId < 14; symId++) {
                if(!betClusterWins.reelWinPositions[reelId][symId]) {
                    continue;
                }
                const sym = PearlHarbor.allReelsView.mainReelModels[reelId].getSymbolByTargetPosition(symId);
                if(!sym) {
                    continue;
                }
                if(sym.isWild) {
                    continue;
                }
                const viewPosition = PearlHarborHelper.getReelPos(reelId);
                let x = viewPosition[0] - PearlHarborGameConfig.symbolWidth * 0.5;
                // in last reel
                if(textWidth > PearlHarborGameConfig.symbolWidth) {
                    x -= (textWidth - PearlHarborGameConfig.symbolWidth);
                }
                return [x, viewPosition[1] + sym.y + 30, symId === 0 ? 10 : 80];
            }
        }
        debugger;
        return [0, 0];
    }
}